import TokenService from "../services/storage.service";

const getters = {
  getMe: (state) => state.user || TokenService.getUser(),
  getBankStatementHeadersStandard: (state) =>
    state.bankStatement.columns?.tableHeaders,
  getBankStatementHeadersBoosters: (state) =>
    state.bankStatement.columns?.boosters,
  getBankStatementHeadersAdditional: (state) =>
    state.bankStatement.columns?.all,
  getUserAddresses: (state) => state.addresses,
  getSelectedAddress: (state) => state.addressSelected,
  getPoints: (state) => state.bankStatement.columns?.allPoints,
  getBankStatementData: (state) => state.bankStatement.data,
  getLastBankStatement: (state) => state.lastBankStatement,
  getLastMonthPoints: (state) => state.bankStatement.lastMonthPoints,
  getCurrentMonthMinus: (state) => state.bankStatement.currentMonthMinus,
  getCurrentMonthPlus: (state) => state.bankStatement.currentMonthPlus,
  getLastMonthKickbacks: (state) => state.bankStatement.lastMonthKickbacks,
  getCurrentMonthKickbacksMinus: (state) =>
    state.bankStatement.currentMonthKickbacksMinus,
  getCurrentMonthKickbacksPlus: (state) =>
    state.bankStatement.currentMonthKickbacksPlus,
  getPointsFromCurrentYear: (state) =>
    state.bankStatement.pointsFromCurrentYear,
  getPointsAtRiskOfExpiry: (state) => state.bankStatement.pointsAtRiskOfExpiry,
  getCategories: (state) => state.categories,
  getProducts: (state) => state.products,
  getProfile: (state) => state.profile,
  getMessages: (state) => state.messages,
  getMessageDetail: (state) => state.messageDetail,
  getMessageDetailLoading: (state) => state.messageDetailLoading,
  getProductsMeta: (state) => state.productsMeta,
  getProductsPageNumber: (state) => state.productsPageNumber,
  getBestSoldProducts: (state) => state.bestSoldProducts,
  getSeasonalProducts: (state) => state.seasonalProducts,
  getSoonAffordableProducts: (state) => state.soonAffordableProducts,
  getProduct: (state) => state.product,
  getCart: (state) => state.cart,
  getProductRequestSent: (state) => state.productRequestSent,
  getCategoriesRequestSent: (state) => state.categoriesRequestSent,
  getTraining: (state) => state.training,
  getTrainings: (state) => state.trainings,
  getQuestions: (state) => state.questions,
  getTrainingResult: (state) => state.trainingResult,
  getTrainingPoints: (state) => state.hasPoints,
  getEndQuizDate: (state) => state.endQuizDate,
  getBTrainings: (state) => state.btrainings,
  getBTraining: (state) => state.btraining,
  getBTrainingDetails: (state) => state.bTrainingDetails,
  getBTrainingCosts: (state) => state.bTrainingCosts,
  getBTrainingTypes: (state) => state.bTrainingTypes,
  getBTrainingResult: (state) => state.bTrainingResult,
  getBTrainingLoading: (state) => state.bTrainingLoading,
  getUserSlides: (state) => state.userSlides,
  getTextPages: (state) => state.textPages,
  getTextPage: (state) => state.textPage,
  getWatchedVideo: (state) => state.watchedVideo,
  getPending: (state) => state.isPending,
  getToast: (state) => state.toast,
  getUserOrders: (state) => state.userOrders,
  getUserOrder: (state) => state.userOrder,
  getUserPromotions: (state) => state.userPromotions,
  getNewsFeeds: (state) => state.newsFeeds,
  getNewsFeedsMeta: (state) => state.newsFeedsMeta,
  getCurrentNewsFeed: (state) => state.currentNewsFeed,
  getUserProducts: (state) => state.userProducts,
  getWholesalers: (state) => state.wholesalers,
  getGroups: (state) => state.groups,
  getSingleHunter: (state) => state.singleHunter,
  getPrices: (state) => state.prices,
  getPriceCategories: (state) => state.priceCategories,
  getSinglePriceList: (state) => state.singlePriceList,
  getVehicleTyres: (state) => state.vehicleTyres,
  getPointsByCsNumber: (state) => state.pointsByCustomerNumber,
  getShowNewInvestment: (state) => state.investmentSupportNew,
  getCertificateTexts: (state) => state.certificateTexts,
  getPercentageNum: (state) => state.profilePercentageNum,
  getMenu: (state) => state.menu,
  getUnreadMessages: (state) => state.unreadMessages,
  getMessagesIsLoading: (state) => state.messagesIsLoading,
  getKickbackInfo: (state) => state.kickbackInfo,
  getMediaCategories: (state) => state.mediaCategories,
  getSingleMedia: (state) => state.singleMedia,
  getSingleMediaCategory: (state) => state.singleMediaCategory,
  getAllDealersNumber: (state) => state.allDealers,
  getWshSelect: (state) => state.wshSelect,
  getIsUnknown: (state) => state.inUnknownGroup,
  getDefaultBanners: (state) => state.defaultBanners,
  getDealerApps: (state) => state.dealerApps,
  getPermissions: (state) => state.permissions || TokenService.getPermissions(),
  getMediaFiles: (state) => state.mediaFiles,
  getPaginationLinks: (state) => state.paginationLinks,
  getTotalMediaFiles: (state) => state.totalMediaFiles,
  getTyreLimit: (state) => state.tyreLimit,
  getPromotions: (state) => state.promotions,
  getAllWholesalers: (state) => state.allWholesalers,
  getBrochureCategories: (state) => state.brochureCategories,
  getFileBrochures: (state) => state.brochureFiles,
  getMainBoxes: (state) => state.mainBoxes,
  getFetchMenu: (state) => state.fetchMenu,
  getFetchLeftColumn: (state) => state.fetchLeftColumn,

  getAccessRestricted: (state) => state.accessRestricted,
  getAccessData: (state) => state.accessData,
  getInitialSurveyStep: (state) => state.initialSurveyStep,
  getParentAttributes: (state) => state.parentAttributes,
  getInitialParentAttributes: (state) => state.initialParentAttributes,
  getBussinessUnits: (state) => state.businessUnits,
  getIsProfilePending: (state) => state.profileIsPending,
  getIsMePending: (state) => state.meIsPending,
  // tenancy part
  isLiteVersion: () => {
    return true;
  },
  availableModules: (state) => {
    return [...state.availableModules]; // Spread to extract array values and make it plain
  },
  tenancyEnabled: (state) => {
    return state.tenancyEnabled;
  },
  tenantId: (state) => {
    return state.tenantId;
  },
  bothRelationOptionDisabled: (state) => {
    return state.bothRelationOptionDisabled;
  },
  fleetRelationOptionDisabled: (state) => {
    return state.fleetRelationOptionDisabled;
  },
  noBussinesRelationOptionDisabled: (state) => {
    return state.noBussinesRelationOptionDisabled;
  },
  directRelationOptionDisabled: (state) => {
    return state.directRelationOptionDisabled;
  },
  getCurrentLocale: (state) => {
    return state.currentLocale;
  },
  getNoRequiredPersonalData: (state) => {
    return state.noRequiredPersonalData;
  },
  getAboutPage: (state) => {
    return state.aboutPage;
  },
  getContactService: (state) => {
    return state.contactService;
  },
  getTenantPermissions: (state) => {
    return state.tenantPermissions;
  },
  getTenantModuleConfigs: (state) => {
    return state.tenantModuleConfigs || {};
  },
  getModuleConfig:
    (state) =>
    (moduleSlug, configKey, defaultValue = null) => {
      const moduleConfig = state.tenantModuleConfigs?.[moduleSlug];
      if (!moduleConfig || moduleConfig[configKey] === undefined) {
        return defaultValue;
      }
      return moduleConfig[configKey];
    },
  isModuleConfigEnabled:
    (state, getters) =>
    (moduleSlug, configKey) => {
      const value = getters.getModuleConfig(moduleSlug, configKey);
      if (value === true || value === 1) {
        return true;
      }
      if (typeof value === "string") {
        return ["1", "true"].includes(value.toLowerCase());
      }
      return false;
    },
  getSliderIsLoading: (state) => {
    return state.sliderIsLoading;
  },
  getCanSeeCartIcon: (state) => {
    return state.canSeeCartIcon;
  },
  getPointBoard: (state) => {
    return state.pointBoard;
  },
  getDealerAppsPending: (state) => {
    return state.dealerAppsPending;
  },
  getBonusMultiplicator: (state) => state.bonusMultiplicator,
  getPointBonusByYear: (state) => state.pointBonusByYear,
  getCurrentPoints: (state) => state.currentPoints,
  getCurrentKickbacks: (state) => state.currentKickbacks,
};

export { getters };
